// src/pages/ComingSoon.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getPrimaryColor } from "../GlobalFunction/Theme";

export default function ComingSoon() {
  return (
    <Box
      component="main"
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        overflow: "hidden",
        bgcolor: "#fffffc",
      }}
    >
      {/* ───────── DESKTOP / TABLET (md+) : full-screen hero ───────── */}
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          position: "relative",
          width: "100%",
          height: "100vh",
        }}
      >
        {/* background */}
        <Box
          component="img"
          src="/img/comingsoon-01.webp"
          alt="SEHO life coming soon"
          sx={{
            position: "fixed",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
            objectPosition: "right",
            zIndex: 0,
          }}
        />

        {/* text + button */}
        <Box
          sx={{
            position: "absolute",
            zIndex: 1,
            top: "60%",
            left: { xs: "10%", md: "16%", lg: "14%" },
            transform: "translateY(-50%)",
            maxWidth: { xs: 200, md: 400, lg: 480 },
            fontFamily:
              '"LINE Seed TW","Noto Sans TC",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,"PingFang TC","Microsoft JhengHei",sans-serif',
            color: "#837f7f",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: { xs: 15, md: 25, lg: 32 },
                mb: 2,
                lineHeight: 1.3,
                textAlign: "center",
              }}
            >
              Coming Soon
            </Typography>

            <Box
              component="a"
              href="/"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.2,
                width: { md: 190, lg: 200 },
                height: { md: 48, lg: 50 },
                px: { md: 3, lg: 3.5 },
                borderRadius: 999,
                cursor: "pointer",
                textDecoration: "none",
                backgroundColor: "#e78a20",
                color: "#fff",
                fontWeight: 400,
                fontSize: { md: 16, lg: 22 },
                fontFamily: "LINE Seed TW",
                lineHeight: 1,
                transition: "transform .18s ease",

                "@keyframes arrowSlideLeftDesk": {
                  "0%": { transform: "translateX(6px)", opacity: 0.2 },
                  "60%": { transform: "translateX(0)", opacity: 1 },
                  "100%": { transform: "translateX(-2px)", opacity: 1 },
                },
                "&:hover": {
                  transform: "translateY(-2px)",
                },
                "&:hover .btn-arrow-desk": {
                  animation: "arrowSlideLeftDesk .45s ease-out both",
                },
              }}
            >
              <ArrowBackIcon
                className="btn-arrow-desk"
                sx={{ fontSize: { md: 22, lg: 25 } }}
              />
              <Box sx={{ lineHeight: 1 }}>返回首頁</Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* ───────── MOBILE (xs–sm) : use ButtonCard layout ───────── */}
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          width: "100%",
          py: "55%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 1280,
            mx: "auto",
            px: { xs: 2, sm: 2.5 },
          }}
        >
          <Box
            sx={{
              position: "relative",
              overflow: "hidden",
              aspectRatio: {
                xs: "16 / 10",
                sm: "16 / 9",
              },
            }}
          >
            {/* background image (no crop, center) */}
            <Box
              component="img"
              src="/img/comingsoon.jpg"
              alt="SEHO life"
              sx={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />

            {/* overlay: Coming Soon text + button, positioned like reference */}
            <Box
              sx={{
                position: "absolute",
                left: { xs: "10%", sm: "10%" },
                top: { xs: "50%", sm: "50%" },
                transform: "translateY(-50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.5,
                fontFamily:
                  '"LINE Seed TW","Noto Sans TC",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,"PingFang TC","Microsoft JhengHei",sans-serif',
                color: "#222",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: 10, sm: 10 },
                  lineHeight: 1,
                  textAlign: "center",
                  // mb: 0.5,
                }}
              >
                Coming Soon
              </Typography>

              {/* button: same href & style as ComingSoon, but sized like CTA card */}
              <Box
                component="a"
                href="/"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1.0,
                  width: { xs: 100, sm: 100 },
                  height: { xs: 18, sm: 20 },
                  px: { xs: 2, sm: 2.2 },
                  borderRadius: 999,
                  cursor: "pointer",
                  textDecoration: "none",
                  backgroundColor: "#e78a20",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: { xs: 10, sm: 12 },
                  fontFamily: "LINE Seed TW",
                  lineHeight: 1,
                  userSelect: "none",
                  transition:
                    "transform .18s ease, box-shadow .18s ease, background-color .18s ease",

                  "@keyframes arrowSlideLeftMobile": {
                    "0%": { transform: "translateX(6px)", opacity: 0.2 },
                    "60%": { transform: "translateX(0)", opacity: 1 },
                    "100%": { transform: "translateX(-2px)", opacity: 1 },
                  },
                  "&:hover": {
                    transform: "translateY(-2px)",
                  },
                  "&:hover .btn-arrow-mobile": {
                    animation: "arrowSlideLeftMobile .45s ease-out both",
                  },
                }}
              >
                <ArrowBackIcon
                  className="btn-arrow-mobile"
                  sx={{ fontSize: { xs: 18, sm: 20 } }}
                />
                <Box sx={{ lineHeight: 1 }}>返回首頁</Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
